const tooltipTitle = 'Schema library version is published';
export default tooltipTitle;
